import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70114885"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base_textarea_form" }
const _hoisted_2 = ["name", "id", "rows", "placeholder"]
const _hoisted_3 = { class: "base_textarea_form_count_denominator" }
const _hoisted_4 = { class: "base_textarea_form_count_numerator" }

import { PropType, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTextareaForm',
  props: {
  id: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String as PropType<HTMLTextAreaElement['placeholder']>,
    default: '',
  },
  modelValue: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isError: {
    type: Boolean,
    default: false,
  },
  rows: {
    type: Number as PropType<HTMLTextAreaElement['rows']>,
    default: 2,
  },
  maxCount: {
    type: Number,
    default: 200,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const value = computed({
  get: () => props.modelValue,
  set: (value) => {
    value = value.replace(/</g, '＜');
    value = value.replace(/>/g, '＞');
    emit('update:modelValue', value);
  },
});

const curretCount = computed(() => {
  if (props.modelValue === null) {
    return 0;
  }
  return props.modelValue.length;
});

const isCountError = computed(() => {
  return curretCount.value > props.maxCount;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      class: _normalizeClass(["base_textarea_form_input", { 'is-error': props.isError || _unref(isCountError) }]),
      name: props.name,
      id: props.id,
      rows: props.rows,
      placeholder: props.placeholder,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
    }, null, 10, _hoisted_2), [
      [_vModelText, _unref(value)]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["base_textarea_form_count", { 'is-error': _unref(isCountError) }])
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(curretCount)), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(props.maxCount), 1)
    ], 2)
  ]))
}
}

})